mutation LockInvestmentPeriod($id: ID!) {
  lockInvestmentPeriod(input: { id: $id }) {
    investmentPeriod {
      id
      name
      openingDate
      closingDate
      lockedDate
    }
  }
}
